import script from "./ProgramVersionDesignsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramVersionDesignsCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramVersionDesignsCard.vue?vue&type=style&index=0&id=6737cb58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6737cb58"]])

export default __exports__